import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetNameParams } from '../types/actionParams';

export class SetProjectNameRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('setProjectName', {
      id: id,
      name: name
    });
  }
}
